"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assign = void 0;
function assign(...args) {
    const [arg, ...rest] = args;
    return Object.assign(arg, ...rest);
}
exports.assign = assign;
//# sourceMappingURL=utils.js.map